import React from "react";
import { Footer, Header } from "../../lib";
import { PrivateProvider } from "./privateContext";

export default function PrivateLayout(props) {
  const { component: Component, ...rest} = props;
  return (
    <PrivateProvider value={{
      ...rest
    }}>
    <Header />
    <Component {...rest}/>
    <Footer isPublic={false} />
    </PrivateProvider>
  )
}